export class InsufficientFund extends Error {
	constructor(required: number, balance: number) {
		super(`Account has insufficient SOL balance. Required(${required}) Balance(${balance})`);
	}
}